<script lang="ts">
	import { format } from '../../../../services/i18n';
	import type { Device } from '../../../../types/Device';
	import VoltageProtectionOverUnder from './VoltageProtectionOverUnder.svelte';
	import type { VoltageProtectionLimits } from './voltage_protection_constants';

	export let device: Device;

	const limits: VoltageProtectionLimits = {
		undervoltage: { min: 180, max: 230 },
		overvoltage: { min: 230, max: 280 },
	};

	const defaultsAlertMessage = `
		<ul class="mt-0 mb-0">
			<li>
				${$format('under_voltage_0_v', {
						default: 'Under voltage:<strong> 0 V</strong>',
					})}
			</li>
			<li>
				${$format('over_voltage_280_v', {
						default: 'Over voltage:<strong> 280 V</strong>',
					})}
			</li>
		</ul>`;
</script>

<VoltageProtectionOverUnder {device} {limits} idPrefix="cb" {defaultsAlertMessage} />
